import http from "@/services/http";

/**
 * Publicidad de la plataforma: campañas que BissTrack administra desde admin-clientes
 * y que el POS muestra (ventana de lanzamiento, banner del Inicio, barra del POS,
 * tarjeta del menú, novedad en la campana).
 *
 * El servidor ya filtra por comercio, vigencia y frecuencia según los eventos del
 * usuario, y devuelve como máximo una campaña por tipo.
 *
 * Las rutas se llaman "novedades": los bloqueadores de anuncios cortan cualquier URL
 * que contenga "publicidad" (ERR_BLOCKED_BY_CLIENT). Los nombres en el código quedan.
 */
export const EVENTOS = Object.freeze(["vista", "clic", "cerrada", "no_mostrar"]);

export default {
  async obtenerActivas() {
    const { data } = await http.get("novedades/activas");
    return (data && Array.isArray(data.data) && data.data) || [];
  },

  registrarEvento(idCampania, evento) {
    if (!EVENTOS.includes(evento)) {
      return Promise.reject(new Error(`Evento de publicidad desconocido: ${evento}`));
    }
    return http.post("novedades/eventos", { id_campania: idCampania, evento });
  },
};
